import AllEventsReportContainer from '@/src/components/reports/AllEventsReportContainer';
import { EventReportContainer } from '@/src/components/reports/EventReportContainer';
import { useUser } from '@/src/store/user.context';
import { Report } from '@/src/types/Report';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, ColumnLayout, Container, ContentLayout, Header, Select } from '@amzn/awsui-components-react';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ReportContainer = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const exportBtnRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState<OptionDefinition | null>(null);

  const dropdownOptions = useMemo(() => {
    // Default reports accessible to any event owners
    const options = [{ label: t(i18nKeys.reports.eventReport), value: Report.EVENT_REPORT }];

    // Only accessible to Jam Admins
    if (user?.isSuperAdmin) {
      options.push({ label: t(i18nKeys.reports.allEvents), value: Report.ALL_EVENTS });
    }

    return options;
  }, [user]);

  const getContent = () => {
    if (selectedOption?.value === Report.EVENT_REPORT) {
      return <EventReportContainer />;
    }

    if (selectedOption?.value === Report.ALL_EVENTS) {
      return <AllEventsReportContainer exportBtnRef={exportBtnRef} />;
    }

    return null;
  };

  return (
    <ContentLayout disableOverlap header={<Header>{t(i18nKeys.reports.title)}</Header>}>
      <Container
        header={
          <Header actions={<div data-testid="reports__export-btn-portal" ref={exportBtnRef} />}>
            {t(i18nKeys.reports.chooseReport)}
          </Header>
        }
      >
        <ColumnLayout columns={1} borders="horizontal">
          <Box float="left">
            <Select
              data-testid="select-report-dropdown"
              selectedOption={selectedOption}
              placeholder={t(i18nKeys.reports.selectReport)}
              ariaLabel={t(i18nKeys.reports.chooseReport)}
              options={dropdownOptions}
              onChange={({ detail }) => {
                setSelectedOption(detail.selectedOption);
              }}
            />
          </Box>
          <Box>{getContent()}</Box>
        </ColumnLayout>
      </Container>
    </ContentLayout>
  );
};

export default ReportContainer;
